import { FormWizardOption } from "./WizardReducer.types";

export const standardFormWizardOptions: FormWizardOption[] = [
	{
		display: "Welcome",
		visited: false,
		active: true,
	},
	{
		display: "Getting Started",
		visited: false,
		active: false,
	},
	{
		display: "Production",
		visited: false,
		active: false,
	},
	{
		display: "Review",
		visited: false,
		active: false,
	},
];

export const elevenYearFormWizardOptions: FormWizardOption[] = [
	{
		display: "Welcome",
		visited: false,
		active: true,
	},
	{
		display: "Getting Started",
		visited: false,
		active: false,
	},
	{
		display: "Membership Type",
		visited: false,
		active: false,
	},
	{
		display: "Production",
		visited: false,
		active: false,
	},
	{
		display: "Review",
		visited: false,
		active: false,
	},
];

export const disabilityApprovedFormWizardOptions: FormWizardOption[] = [
	{
		display: "Welcome",
		visited: false,
		active: true,
	},
	{
		display: "Getting Started",
		visited: false,
		active: false,
	},
	{
		display: "Review",
		visited: false,
		active: false,
	},
];

export default {};
